import { CircularProgress } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { DONATIONS_LIST_TYPE } from "../constants";
import { fundRaiserPageAction } from "../store/actions";
import { DonorCard } from "./DonorCard";
import { EmptyDataDiv } from "./EmptyDataDiv";

export function DonationList({ donations, totalDonations, listType, targetDiv }) {

    const dispatch = useDispatch();
    const { HIGHEST_DONATIONS, RECENT_DONATIONS } = DONATIONS_LIST_TYPE;
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    const [state, setState] = useState({
        limit: 10,
        offset: 0
    })

    const loadDonations = () => {
        switch (listType) {
            case HIGHEST_DONATIONS:
                dispatch(fundRaiserPageAction.getFundraiserMostDonated(pageDetails.id, state.limit, state.offset));
                break;

            case RECENT_DONATIONS:
                dispatch(fundRaiserPageAction.getFundraiserRecentDonations(pageDetails.id, state.limit, state.offset));
                break;

            default:
                break;
        }
    }

    const updateOffset = () => {
        setState({
            ...state,
            offset: state.offset + state.limit
        });
    }

    useEffect(() => {
        if (state.offset > 0) {
            loadDonations();
        }
    }, [state.offset]);

    return donations && donations.length ? <InfiniteScroll
        dataLength={donations.length}
        next={updateOffset}
        hasMore={donations.length < totalDonations}
        loader={
            <div style={{ textAlign: "center" }}>
                <CircularProgress thickness={2} />
            </div>
        }
        style={{
            overflow: 'hidden'
        }}
        scrollableTarget={targetDiv}
    >
        {
            donations.map(donor => {
                return <DonorCard
                    key={donor.id}
                    isTeamDonor={false}
                    data={donor}
                    pageDetails={pageDetails}
                />
            })
        }
    </InfiniteScroll> : <EmptyDataDiv message="No donations yet" />
}